import { appInsights } from 'src/App';

export const analyticsEventSend = (eventName: string, buttonName?: string) => {
  appInsights.trackEvent({
    name: eventName,
    properties: { buttonName: buttonName || 'default' },
  });
};
